module.exports = __webpack_public_path__ + "static/media/1_en.df1302ef.png";